import React from 'react';
import { Link } from 'react-router-dom';
import Score from '../Helpers/Score';
import Avatar from '../Helpers/Avatar';

const UserCard = function (props) {
  const {
    id, distance, displayName, score
  } = props;
  const roundedDistance = Math.round(distance * 10) / 10;
  return (
    <article className="usercard">
      <div>
        <div className="avatarInUserCard">
          {<Avatar alt={displayName} {...props} />}
        </div>
        <div className="userinfo">
          {displayName}
        </div>
      </div>
      <div>
        <div className="distance">
          {roundedDistance} km
        </div>
        <div className="scoreInUserCard">
          <Score score={score} />
        </div>
        <div className="actions">
          <Link to={`/user/${id}`}>Zum Profil</Link>
        </div>
      </div>

    </article>
  );
};

export default UserCard;




// WEBPACK FOOTER //
// ./src/pages/Search/UserCard.js